import { useSuspenseQuery } from "@tanstack/react-query"

import { getUsage, type Granularity } from "../../app/services/usage"

export function useUsageQuery(
  startDate: Date,
  endDate: Date,
  granularity: Granularity = "daily",
) {
  return useSuspenseQuery({
    queryKey: ["usage", { startDate, endDate, granularity }],
    queryFn: () => getUsage({ startDate, endDate, granularity }),
  })
}
